<template>
    <div class="te-price-list">
        <div class="te-price-list__row te-price-list__header">
            <div class="te-price__type">{{languageSettings.type}}</div>
            <div class="te-price__amount">{{languageSettings.price}}</div>
            <div class="te-price__quantity">{{languageSettings.quantity}}</div>
        </div>
        <price
                v-for="(price, i) in pricesClone"
                v-bind:key="price.conditionId"
                :ref="price.conditionId"
                :name="price.description"
                :amount="price.amount"
                :currency="price.currency"
                :limit="price.limit"
                :default-quantity="price.quantity"
                :tab-index="i"
                :language="languageSettings"
                @change="onQuantityChange(price, $event)"
        ></price>
        <button name="add-to-cart" class="te-button te-primary-action" :disabled="!hasSelectedPrices" @click="onAddToCart">{{languageSettings.addToCart}}</button>
    </div>
</template>

<script>
    // import { mapGetters, mapActions } from "vuex";
    // import { mapGetters } from "vuex";
    import Price from './Price'

    export default {
        name: "PriceList",

        components: {
            Price
        },

        data() {
            return {
                pricesClone: [],
            };
        },

        props: {
            prices: {
                type: Array,
                required: true,
                validator: (prices) => {
                    var isValid = true;
                    if( !(prices instanceof Array) ) {
                        isValid = false;
                    }
                    prices.forEach(p => {
                        if( !(p && p.type && (p.type === 'access' || p.type === 'product') && p.conditionId && p.amount !== null && p.amount !== undefined && p.tax !== null && p.tax !== undefined && p.description && p.conditionPath && (p.accessDefinitionId || p.productDefinitionId)) ) {
                            isValid = false;
                        }
                        if(p.amount > 0 && p.currency === null) {
                            isValid = false;
                        }
                    });
                    return isValid;
                }
            },
            language: {
                type: Object
            },
        },

        computed: {
            // ...mapGetters({
            //     error: 'error',
            //     jobs: 'jobs',
            //     // eventId: 'eventId',
            //     // orderId: 'orderId',
            //     // customerId: 'customerId',
            //     event: 'event',
            //     eventPriceList: 'eventPriceList'
            // }),
            //
            // isLoading: function() {
            //     return (
            //         this.jobs.includes("get-event") ||
            //         this.jobs.includes("get-price-list")
            //     );
            // },

            languageSettings: function() {
                const defaultSettings = {
                    type: 'Type',
                    price: 'Price',
                    quantity: 'Quantity',
                    addToCart: 'Add to cart',
                };
                return Object.assign(defaultSettings, this.language);
            },

            hasSelectedPrices: function() {
                const reducer = (totalQuantity, price) => totalQuantity + price.quantity;
                return this.pricesClone.reduce(reducer, 0) > 0;
            }
        },

        methods: {
            // ...mapActions([
            //     "getEventPriceList",
            //     "getEvent"
            // ]),

            onQuantityChange(price, quantity) {
                price.quantity = parseInt(quantity);
                this.$emit('change', this.pricesClone);
            },

            resetPriceQuantities() {
                if(this.$children) {
                    this.$children.forEach(child => {
                        if(child && child.resetQuantity) {
                            child.resetQuantity();
                        }
                    });
                }
            },

            onAddToCart() {
                this.resetPriceQuantities();
                this.$emit('add', this.pricesClone);
            }
        },

        watch: {
            prices: function(newVal) {
                this.pricesClone = newVal;
            }
        },

        created() {
            if(this.prices) {
                this.pricesClone = this.prices;
            }
        }
    }
</script>

<style scoped>

</style>
